const INSERT_GALLERY_BUTTON = "insert-gallery-button";
const ROOT = "gallery-viewer";
const PLUGIN_TOOLBAR_MANAGE_MEDIA_BUTTON = "plugin-toolbar-manage-media-button";
const PLUGIN_TOOLBAR_ADD_MEDIA_BUTTON = "plugin-toolbar-add-media-button";
const PLUGIN_TOOLBAR_LAYOUT_DROPDOWN_BUTTON = "plugin-toolbar-layout-dropdown-button";
const LAYOUT_SELECTION_DROPDOWN = "gallery-layout-selection-dropdown";
const LAYOUT_DROPDOWN_OPTION_CUSTOMIZE_LAYOUT = "layout-dropdown-option-customize-layout";
const LAYOUT_DROPDOWN_OPTION = "layout-dropdown-option-";
const SETTINGS_MODAL = "gallery-settings-modal";
const SETTINGS_TABS = "settings-tabs";
const GENERAL_SETTINGS_EXPAND_TOGGLE = "general-settings-expand-toggle";
const GENERAL_SETTINGS_DOWNLOAD_TOGGLE = "general-settings-download-toggle";
const GENERAL_SETTINGS_SPOILER_TOGGLE = "general-settings-spoiler-toggle";
const MEDIA_SETTINGS_SORTABLE_ITEMS = "media-settings-sortable-items";
const MEDIA_SETTINGS_DELETE_ITEMS_BUTTON = "media-settings-delete-items-button";
const MEDIA_SETTINGS_SELECT_ALL_ITEMS_BUTTON = "media-settings-select-all-items-button";
const MEDIA_SETTINGS_DESELECT_ALL_ITEMS_BUTTON = "media-settings-deselect-all-items-button";
const MEDIA_SETTINGS_EDIT_ITEM_BUTTON = "media-settings-edit-item-button";
const MEDIA_SETTINGS_ADD_MEDIA_INPUT = "media-settings-add-media-input";
const MEDIA_SETTINGS_SORTABLE_ITEMS_CONTAINER = "media-settings-sortable-items-container";
const MEDIA_ITEM_SETTINGS_DELETE_BUTTON = "media-item-settings-delete-button";
const MEDIA_ITEM_SETTINGS_CAROUSEL = "media-item-settings-carousel";
const MEDIA_ITEM_SETTINGS_ADD_LINK_BUTTON = "media-item-settings-add-link-button";
const MEDIA_ITEM_SETTINGS_ADD_EDIT_LINK_BUTTON = "media-item-settings-edit-link-button";
const MEDIA_ITEM_SETTINGS_REPLACE_BUTTON = "media-item-settings-replace-button";
const MEDIA_ITEM_SETTINGS_CAPTION_INPUT = "media-item-settings-caption-input";
const MEDIA_ITEM_SETTINGS_ALT_INPUT = "media-item-settings-alt-input";
const LAYOUT_SETTINGS_LAYOUT_THUMBNAIL_PICKER = "layout-settings-layout-thumbnail-picker";
const LAYOUT_SETTINGS_LAYOUT_THUMBNAIL = "layout-settings-layout-thumbnail-";
const LAYOUT_SETTINGS_THUMBNAIL_CROP_SEGMENTED_TOGGLE = "layout-settings-thumbnail-crop-segmented-toggle";
const LAYOUT_SETTINGS_IMAGE_ORIENTATION_SEGMENTED_TOGGLE = "layout-settings-image-orientation-segmented-toggle";
const LAYOUT_SETTINGS_SCROLL_DIRECTION_SEGMENTED_TOGGLE = "layout-settings-image-scroll-direction-segmented-toggle";
const LAYOUT_SETTINGS_THUMBNAIL_PLACEMENT_THUMBNAIL_PICKER = "layout-settings-thumbnail-placement-thumbnail-picker";
const LAYOUT_SETTINGS_THUMBNAIL_PLACEMENT_THUMBNAIL = "layout-settings-thumbnail-placement-thumbnail-";
const LAYOUT_SETTINGS_ITEMS_PER_ROW_SLIDER = "layout-settings-items-per-row-slider";
const LAYOUT_SETTINGS_ITEMS_PER_ROW_INPUT = "layout-settings-items-per-row-input";
const LAYOUT_SETTINGS_THUMBNAIL_SIZE_SLIDER = "layout-settings-thumbnail-size-slider";
const LAYOUT_SETTINGS_THUMBNAIL_SIZE_INPUT = "layout-settings-thumbnail-size-input";
const LAYOUT_SETTINGS_SPACING_BETWEEN_ITEMS_SLIDER = "layout-settings-spacing-between-items-slider";
const LAYOUT_SETTINGS_SPACING_BETWEEN_ITEMS_INPUT = "layout-settings-spacing-between-items-input";
const LAYOUT_SETTINGS_SPACING_BETWEEN_THUMBNAILS_SLIDER = "layout-settings-spacing-between-thumbnails-slider";
const LAYOUT_SETTINGS_SPACING_BETWEEN_THUMBNAILS_INPUT = "layout-settings-spacing-between-thumbnailss-input";
const LAYOUT_SETTINGS_IMAGE_RATIO_THUMBNAIL_PICKER = "layout-settings-image-ratio-thumbnail-picker";
const LAYOUT_SETTINGS_IMAGE_RATIO_THUMBNAIL = "layout-settings-image-ratio-thumbnail-";
export {
  GENERAL_SETTINGS_DOWNLOAD_TOGGLE,
  GENERAL_SETTINGS_EXPAND_TOGGLE,
  GENERAL_SETTINGS_SPOILER_TOGGLE,
  INSERT_GALLERY_BUTTON,
  LAYOUT_DROPDOWN_OPTION,
  LAYOUT_DROPDOWN_OPTION_CUSTOMIZE_LAYOUT,
  LAYOUT_SELECTION_DROPDOWN,
  LAYOUT_SETTINGS_IMAGE_ORIENTATION_SEGMENTED_TOGGLE,
  LAYOUT_SETTINGS_IMAGE_RATIO_THUMBNAIL,
  LAYOUT_SETTINGS_IMAGE_RATIO_THUMBNAIL_PICKER,
  LAYOUT_SETTINGS_ITEMS_PER_ROW_INPUT,
  LAYOUT_SETTINGS_ITEMS_PER_ROW_SLIDER,
  LAYOUT_SETTINGS_LAYOUT_THUMBNAIL,
  LAYOUT_SETTINGS_LAYOUT_THUMBNAIL_PICKER,
  LAYOUT_SETTINGS_SCROLL_DIRECTION_SEGMENTED_TOGGLE,
  LAYOUT_SETTINGS_SPACING_BETWEEN_ITEMS_INPUT,
  LAYOUT_SETTINGS_SPACING_BETWEEN_ITEMS_SLIDER,
  LAYOUT_SETTINGS_SPACING_BETWEEN_THUMBNAILS_INPUT,
  LAYOUT_SETTINGS_SPACING_BETWEEN_THUMBNAILS_SLIDER,
  LAYOUT_SETTINGS_THUMBNAIL_CROP_SEGMENTED_TOGGLE,
  LAYOUT_SETTINGS_THUMBNAIL_PLACEMENT_THUMBNAIL,
  LAYOUT_SETTINGS_THUMBNAIL_PLACEMENT_THUMBNAIL_PICKER,
  LAYOUT_SETTINGS_THUMBNAIL_SIZE_INPUT,
  LAYOUT_SETTINGS_THUMBNAIL_SIZE_SLIDER,
  MEDIA_ITEM_SETTINGS_ADD_EDIT_LINK_BUTTON,
  MEDIA_ITEM_SETTINGS_ADD_LINK_BUTTON,
  MEDIA_ITEM_SETTINGS_ALT_INPUT,
  MEDIA_ITEM_SETTINGS_CAPTION_INPUT,
  MEDIA_ITEM_SETTINGS_CAROUSEL,
  MEDIA_ITEM_SETTINGS_DELETE_BUTTON,
  MEDIA_ITEM_SETTINGS_REPLACE_BUTTON,
  MEDIA_SETTINGS_ADD_MEDIA_INPUT,
  MEDIA_SETTINGS_DELETE_ITEMS_BUTTON,
  MEDIA_SETTINGS_DESELECT_ALL_ITEMS_BUTTON,
  MEDIA_SETTINGS_EDIT_ITEM_BUTTON,
  MEDIA_SETTINGS_SELECT_ALL_ITEMS_BUTTON,
  MEDIA_SETTINGS_SORTABLE_ITEMS,
  MEDIA_SETTINGS_SORTABLE_ITEMS_CONTAINER,
  PLUGIN_TOOLBAR_ADD_MEDIA_BUTTON,
  PLUGIN_TOOLBAR_LAYOUT_DROPDOWN_BUTTON,
  PLUGIN_TOOLBAR_MANAGE_MEDIA_BUTTON,
  ROOT,
  SETTINGS_MODAL,
  SETTINGS_TABS
};
//# sourceMappingURL=data-hooks.js.map
